import { ImCheckboxChecked, ImCheckboxUnchecked } from "react-icons/im"
import { useRenterDashboardContext } from "./useRenterDashboardContext"
import { UploadImageField } from "../../../../common/components/form/UploadImageField/UploadImageField"
import { personalAddress } from "../../../../common/helpers/renter-edit-constants"

import { GenericInfoField } from "../../../../common/components/ui/GenericInfoField"
const ASSETS_URL = import.meta.env.VITE_ASSETS_URL
const buildAssetURL = (key: string) => {
  return key ? `${ASSETS_URL}/${key}` : "<span>Enviar arquivo</span>"
}

export function ReferenceAndAddressInfo() {
  const getImageUrl = (content) => {
    if (content &&
      content.startsWith("https://ileva.s3.sa-east-1.amazonaws.com") &&
      content.includes("https://assets.locavibe.com.br/https://ileva.s3.sa-east-1.amazonaws.com")) {
      return buildAssetURL(content)
    }
    return content
  }


  const { renter } = useRenterDashboardContext();
  const personalInfoAddress = personalAddress(renter)
  return (
    <div className="tabs-border-line">
      {/* Endereço e Referências */}
      <section className="tabs-item-style">
        <h2 className="text-2xl font-semibold mb-4">Endereço</h2>
        <div className="grid grid-cols-3 gap-2 mb-4">
          {personalInfoAddress.map((info) => {
            return (<GenericInfoField id={info.id} spanSize={info.spanSize} label={info.label} value={info.value} />)
          })}
        </div>
      </section>

      <div className="div-tabs-border-line"></div>

      <section className="tabs-item-style">
        <h2 className="font-semibold text-2xl mb-4">Referências</h2>
        <div className="grid grid-rows-3">
          {renter.references && renter.references.map((reference, index) => (
            <div className="grid grid-flow-row gap-1" key={index}>
              <label className="font-semibold text-sm">{`Referência ${index + 1}`}</label>
              <div className="w-full grid grid-cols-6 gap-2">
                <div className="col-span-3">
                  <span className="font-regular mr-4 text-sm">Nome: </span>
                  <p className="border border-gray h-[43px] text-gray2 p-2 overflow-hidden rounded w-full bg-[#ffffff]">{reference.name}</p>
                </div>
                <div className="col-span-2">
                  <span className="font-regular mr-4 text-sm">Contato:</span>
                  <p className="border border-gray h-[43px] text-gray2 p-2 overflow-hidden rounded w-full bg-[#ffffff]">{reference.content}</p>
                </div>
                <div className="relative h-20 w-full sm:w-1/5 color flex items-center">
                  <label htmlFor={`references.${index}.verified`} className="block text-sm font-medium text-gray-600">
                    {reference.verified
                      ?
                      <div className="flex flex-row items-center justify-start text-greenPrimary">
                        <ImCheckboxChecked />
                        <span>Verificado</span>
                      </div>
                      :
                      <div className="flex flex-row gap-2 items-center justify-start text-redPrimary">
                        <ImCheckboxUnchecked />
                        <span>Não verificado</span>
                      </div>
                    }
                  </label>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <div className="div-tabs-border-line"></div>

      <section className="tabs-item-style">
        <h2 className="text-2xl font-semibold mb-4">Documentos</h2>
        <section className="grid grid-cols-1 gap-1">
          {renter.documents && renter.documents.map((document, index) => (
            <>
              {
                renter.documents[index].type === 'Comprovante de Endereço' ||
                  renter.documents[index].type === 'Contato de Referência 1' ||
                  renter.documents[index].type === 'Contato de Referência 2' ||
                  renter.documents[index].type === 'Contato de Referência 3' ? (
                  <div className={`mb-4 px-2 py-4 ${index % 2 !== 0 ? 'bg-gray/5' : 'bg-gray/40 rounded'}`} key={index}>
                    <h2 className="font-semibold text-sm">Tipo de Documento:</h2>
                    <div className="flex items-center">
                      <p className="border border-slate-500 text-gray3 h-[34px] min-w-[60%] px-2 py-1 mr-3 rounded bg-white/50">{document.type}</p>
                      <div className="flex flex-wrap items-center">
                        <div className="w-24 h-24 bg-gray/40">
                          {document.content === ''
                            ? <span
                              className="w-full h-full font-semibold flex items-center text-center border border-gray border-dashed text-[#443636] bg-white/50 rounded">Envie um arquivo!</span>
                            : <UploadImageField src={getImageUrl(document.content)} disableTrashIcon={true} />}
                        </div>
                        <div className="mx-2">
                          {document.verified ? (
                            <div className="text-greenPrimary text-md flex flex-row items-center">
                              <ImCheckboxChecked />
                              <span>Verificado</span>
                            </div>
                          ) : (
                            <div className="text-redPrimary text-sm flex flex-row items-center">
                              <ImCheckboxUnchecked />
                              <span>Não verificado</span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
            </>

          ))}
        </section>
      </section>
    </div>
  )
}
export default ReferenceAndAddressInfo